<template>
  <div :class="$style.Container">
    <div :class="$style.Wrapper">
      <div :class="$style.dateText">
        {{ $t('common.dateFrom') }}
      </div>
      <div :class="$style.datePickerWrapper">
        <date-picker
          v-model="dateFrom"
          :class="[$style.datePicker, { [$style.disabled]: disabled }]"
          :disabled="disabled"
          :clearable="clearable"
          format="DD.MM.YYYY"
        />
        <date-picker
          v-model="timeFrom"
          :class="[$style.timePicker, { [$style.disabled]: disabled }]"
          type="time"
          format="HH:mm"
          :disabled="disabled"
          :clearable="clearable"
        />
      </div>
    </div>

    <div :class="$style.Wrapper">
      <div :class="$style.dateText">
        {{ $t('common.dateTo') }}
      </div>
      <div :class="$style.datePickerWrapper">
        <date-picker
          v-model="dateTo"
          :class="[$style.datePicker, { [$style.disabled]: disabled }]"
          :disabled="disabled"
          :clearable="clearable"
          format="DD.MM.YYYY"
        />
        <date-picker
          v-model="timeTo"
          :class="[$style.timePicker, { [$style.disabled]: disabled }]"
          type="time"
          format="HH:mm"
          :disabled="disabled"
          :clearable="clearable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { date, datePicker, dateRouter } from '@/helpers/filters';

export default {
  filters: {
    date,
  },
  components: {
    DatePicker,
  },
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dateFrom: null,
    dateTo: null,
    timeFrom: null,
    timeTo: null,
  }),
  watch: {
    dateFrom(newVal, oldVal) {
      if (newVal && oldVal) this.dateFromChanged();
    },
    dateTo(newVal, oldVal) {
      if (newVal && oldVal) this.dateToChanged();
    },
    timeFrom(newVal, oldVal) {
      if (newVal && oldVal) this.dateFromChanged();
    },
    timeTo(newVal, oldVal) {
      if (newVal && oldVal) this.dateToChanged();
    },
  },
  mounted() {
    const dateRange = this.$store.getters['filters/dateRange'];
    this.dateFrom = datePicker(dateRange[0]);
    this.dateTo = datePicker(dateRange[1]);
    this.timeFrom = datePicker(dateRange[0]);
    this.timeTo = datePicker(dateRange[1]);
  },
  methods: {
    dateFromChanged() {
      const hour = this.timeFrom.getHours();
      const minute = this.timeFrom.getMinutes();
      const second = this.timeFrom.getSeconds();
      const dateFrom = dateRouter(this.dateFrom, hour, minute, second);
      this.$router.replace({
        query: {
          ...this.$router.currentRoute.query,
          dateFrom,
        },
      });
      this.$emit('update');
    },
    dateToChanged() {
      const hour = this.timeTo.getHours();
      const minute = this.timeTo.getMinutes();
      const second = this.timeTo.getSeconds();
      const dateTo = dateRouter(this.dateTo, hour, minute, second);
      this.$router.replace({
        query: {
          ...this.$router.currentRoute.query,
          dateTo,
        },
      });
      this.$emit('update');
    },
  },
};
</script>

<style lang="scss" module>
  .Container {
    display: flex;
    gap: 8px;
  }

  .Wrapper {
    display: flex;
    flex-direction: column;
  }

  .datePickerWrapper {
    display: flex;
    gap: 8px;
  }

  .datePicker,
  .timePicker {
    cursor: pointer;
    &.disabled {
      cursor: not-allowed;
      background: $light-gray;
    }
  }

  .datePicker {
    width: 130px;
  }

  .timePicker {
    width: 85px;
  }

  .datepickerPopup td {
    vertical-align: middle;
  }

  .dateText {
    color: #7e7e7e;
    font-size: 12px;
    margin-bottom: 8px;
  }

  .date {
    font-size: 14px;
  }
</style>

<style>
  .mx-input {
    cursor: pointer;
    border: 1px solid #dfdfdf;
    border-radius: 0;
    color: #000;
    &:hover {
      border-color: #dfdfdf;
    }
  }
</style>
